import * as React from 'react';
import { ListingState, BaseRouteProps } from '../../interfaces';
import { Tenant } from '../../models';
import { TenantDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { DataGrid } from '../../components';

export class TenantListing extends React.Component<BaseRouteProps<{}>, ListingState<Tenant>> {
    private tenantDataService = new TenantDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            entities: new Array<Tenant>(),
        };
    }

    public componentDidMount() {
        this.tenantDataService.getAll().then((tenants: Tenant[]) => {
            this.setState(
                { entities: tenants }
            );
        });
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <span>
                    <NavLink to={`/tenant/${value}`} className="btn btn-default">View</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-xs-7">
                                <div className="title">
                                Tenants
                                </div>
                            </div>
                            <div className="col-xs-5 text-right">
                                <NavLink className="btn btn-primary" to={'/tenant/create'}>
                                    <span className="glyphicon glyphicon-plus" /> Create
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <DataGrid entities={listData} columns={columnDefs} />
                    </div>
                </div>
            </div>);
    }

    // private delete(id: number) {
    //     const entity = this.state.entities.find(e => e.id === id);

    //     var confirmed = confirm(`Are you sure you want to delete ${entity!.name}`);

    //     if (confirmed) {
    //         this.setState({
    //             entities: this.state.entities.filter((tenant: Tenant) => {
    //                 return tenant.id !== entity!.id;
    //             })
    //         });
    //     }
    // }

    // private deleteBinder(id: number): ((event: React.MouseEvent<HTMLElement>) => void) {
    //     return this.delete.bind(this, id);
    // }
}


// WEBPACK FOOTER //
// ./src/components/tenant/TenantListing.tsx